<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="Year" prop="year">
                    <el-date-picker v-model="queryCondition.year" style="width:100%" value-format="yyyy" type="year" placeholder="选择年"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Sponsor" prop="sponsorName">
                    <el-input v-model="queryCondition.sponsorName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Category3" prop="category3Code">
                    <el-select v-model="queryCondition.category3Code" clearable placeholder="请选择" style="width:100%">
                      <el-option :key="index" v-for="(item,index) in category3List" :label="item.object" :value="item.key"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="ASL" prop="aslName">
                    <el-input v-model="queryCondition.aslName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <!-- <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="状态" prop="status">
                        <el-select v-model="queryCondition.status" clearable multiple filterable placeholder="请选择(支持多选)" style="width:100%">
                          <el-option :key="index" v-for="(item,index) in categoryList3" :label="item.name" :value="item.code"></el-option>
                        </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition> -->
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="queryData(1)" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <!-- <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span> -->
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button v-acl="RMC_PROT_3P_ADD" class="btn" type="primary" @click="addList">新增</el-button>
        <el-dropdown v-acl="RMC_PROT_3P_EXPORT" split-button type="primary" @click="handleClick" placement="bottom" style="margin-right: 10px;">
          报表导出
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <el-button size="mini" class="dropdownItemBtn" type="primary" @click="exportAslAuditReport">ASL审核报告</el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-button size="mini" class="dropdownItemBtn" @click="exportHistoryReport" type="primary">历史记录</el-button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button v-acl="RMC_PROT_3P_AUDIT_DOWNLOAD" class="btn" type="danger" @click="downloadAuditReport">审核报告下载</el-button>
      </el-row>
      <ux-grid ref="plxTable" :data="tableData" @selection-change="selectionChange" max-height="500" show-overflow="tooltip" highlight-current-row>
        <ux-table-column align="center" type="checkbox" width="80" />
        <ux-table-column align="center" title="Year" min-width="100" field="year"></ux-table-column>
        <ux-table-column align="center" title="Category3" field="category3Name" width="120" />
        <ux-table-column align="center" title="Sponsor" min-width="100" field="sponsorName"></ux-table-column>
        <ux-table-column align="center" title="ASL" min-width="120" field="aslName"></ux-table-column>
        <ux-table-column align="center" title="3方GMP" min-width="140" field="gmp">
          <template v-slot="scope">
            <el-button type="text" @click="goDetail(scope.row,3)">{{scope.row.gmp}}</el-button>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="3方HACCP" min-width="100" field="haccp"></ux-table-column>
        <ux-table-column align="center" title="3方Antibiotics" min-width="120" field="antibiotics"></ux-table-column>
        <ux-table-column align="center" title="3方AnimaWalfare" min-width="120" field="animalWalfare"></ux-table-column>
        <ux-table-column align="center" :title="`3方${customLabel}`" min-width="100" field="swa">
          <template v-slot="scope">
            <el-button type="text" @click="goDetail(scope.row,3)">{{scope.row.swa}}</el-button>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="3方ASL审核时间" min-width="120" field="aslAuditDate"></ux-table-column>
        <ux-table-column align="center" :title="`3方${customLabel}审核时间`" min-width="120" field="swaAuditDate"></ux-table-column>
        <ux-table-column align="center" title="2方GMP" min-width="120" field="gmpSecond">
          <template v-slot="scope">
            <el-button type="text" @click="goDetail(scope.row,2)">{{scope.row.gmpSecond}}</el-button>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="2方HACCP" min-width="120" field="haccpSecond"></ux-table-column>
        <ux-table-column align="center" title="2方Antibiotics" min-width="120" field="antibioticsSecond"></ux-table-column>
        <ux-table-column align="center" title="2方AnimaWalfare" min-width="120" field="animalWalfareSecond"></ux-table-column>
        <ux-table-column align="center" :title="`2方${customLabel}`" min-width="120" field="swaSecond"></ux-table-column>
        <ux-table-column align="center" title="2方ASL审核时间" min-width="120" field="aslAuditDateSecond"></ux-table-column>
        <ux-table-column align="center" :title="`2方${customLabel}审核时间`" min-width="120" field="swaAuditDateSecond"></ux-table-column>
        <ux-table-column align="center" title="3方审核报告" min-width="120" field="updateDate">
          <template v-slot="scope">
            <el-button type="text" @click="openDetail(scope.row,3)">查看</el-button>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="2方审核报告" min-width="120" field="updateDate">
          <template v-slot="scope">
            <el-button type="text" @click="openDetail(scope.row,2)">查看</el-button>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="3方备注" min-width="120" field="remark"></ux-table-column>
        <ux-table-column align="center" title="2方备注" min-width="120" field="remarkSecond"></ux-table-column>
        <ux-table-column align="center" title="更新人" min-width="120" field="submitUser"></ux-table-column>
        <ux-table-column align="center" title="更新时间" min-width="120" field="submitDate"></ux-table-column>

      </ux-grid>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>

      <el-dialog title="提示" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
        <div slot="title" class="header-title">
          <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
            <p class="line"></p>
            <p class="info_title">更新状态 <span style="font-weight: normal;margin-left:10px;font-size:12px;">如果无更新时，请先在日期后点击确认</span> </p>
          </div>
        </div>
        <updateDialog @close="handleClose"></updateDialog>
      </el-dialog>

      <el-dialog title="" :visible.sync="fileleDialog" width="60%" :before-close="closeFileDialog">
        <div slot="title" class="header-title">
          <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
            <p class="line"></p>
            <p class="info_title">附件</p>
          </div>
        </div>
        <fileleDialog v-if="fileleDialog" :fileList="fileList"></fileleDialog>
      </el-dialog>

    </div>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import store from '@/store/index'
// import detailDialog from './MaintainceFacility.vue'
import commonFunction from "@/utils/dataTableUtils";
import updateDialog from '@/components/page/RMC/Protein/rmcDrugList/updateDialog'
import medicineDosage from "@/api/rmcProtein/medicineDosage";
import proteinDrug from "@/api/rmcProtein/drug";
import { fileService } from "@/api/common/file-utils";
import prot3p from '@/api/rmcProtein/prot3p'
import fileleDialog from '@/components/page/RMC/Protein/Prot3p/dialog/fileleDialog'
import QBRApi from "@/api/QBR/index";
import qspiReport from "@/api/qspiReport/index";
export default {
  name: '',
  components: {
    updateDialog,
    fileleDialog,
    IcSelect,

    // detailDialog
  },
  data() {
    return {
      fileList: [],
      fileleDialog: false,
      identity: localStorage.getItem('ms_emplFlag'),
      dialogVisible: false,
      allDate: [],
      multipleSelection: [],
      categoryList2: [],
      category3List: [],
      statusList: [],
      queryCondition: {
        year: "", // 年份
        sponsorName: '', //sponsor名称
        category3Code: "", //category3 编码
        aslName: "", //asl名称
        pageNum: 1,
        pageSize: 15,
      },
      isShow: false,
      showDetailDialog: false,
      tableData: [],
      formData: null,
      totalCount: "",
      statusView: "",
      customLabel: "",
    }
  },
  created() {
    let queryData = this.$store.state.asl.skipQuery
    let qspiInfo = JSON.parse(sessionStorage.getItem('qspiInfo'))
    if (qspiInfo) {
      if (qspiInfo.SPONSOR_NAME) {
        this.$set(this.queryCondition, 'sponsorName', qspiInfo.SPONSOR_NAME)
      }
    }
    // if(queryData.sponsorName){
    //   this.$set(this.queryCondition,'sponsorName',queryData.sponsorName)
    // }
    // if(queryData.category3Code){
    //   this.$set(this.queryCondition,'category3Code',queryData.category3Code)
    // }
    if (queryData.aslName) {
      this.$set(this.queryCondition, 'aslName', queryData.aslName)
    }
    this.getTableLable()
    this.getSelector()
    this.getdCategory3()
    this.queryData();
  },
  destroyed() {
    this.$store.dispatch('saveQueryData', {})
  },
  methods: {
    getTableLable() {
      var year = this.queryCondition.year ? this.queryCondition.year : '9999'
      qspiReport.getQspiMonthlyTbleLabel('SWA', year).then(res => {
        console.log("GY🚀 ~ qspiReport.getQspiMonthlyTbleLabel ~ res:", res);
        this.customLabel = res
      });
    },
    getdCategory3() {
      proteinDrug.getdCategory3().then((res) => {
        this.category3List = res.data.filter((v) => {
          return v.cascadeKey == 'protein'
        })
      })
    },
    getSelector() {
      medicineDosage.getSelector().then((res) => {
        res.data.forEach((v) => {
          let obj = {}
          obj.name = v
          obj.code = v
          this.allDate.push(obj)
        })
      })
    },
    openDetail(val, index) {
      console.log("vvvvvvvvvvv", val)
      QBRApi.getFileLists({
        tsReckindId: index == 3 ? "TRIPARTITY_PARTY_UPLOAD" : "SECOND_PARTY_UPLOAD",
        tsRecId: index == 3 ? val.ttRmcProteinAuditReportId : val.ttRmcProteinAuditReportIdSecond
      }).then(res => {
        this.fileList = res
        this.fileleDialog = true
      });
    },
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1
      }
      prot3p.getAuditReportList(this.queryCondition).then((res) => {
        this.tableData = res.resultData
        this.totalCount = res.totalCount
      })
      this.getTableLable()
    },
    goDetail(row, value) {
      this.$router.push({
        path: "/rmcProt3P/detail",
        query: {
          id: value == 2 ? row.ttRmcProteinAuditReportIdSecond : row.ttRmcProteinAuditReportId
        }
      })
    },
    onReset() {
      this.queryCondition = {
        year: "", // 年份
        sponsorName: '', //sponsor名称
        category3Code: "", //category3 编码
        aslName: "", //asl名称
        pageNum: 1,
        pageSize: 15,
      }
      this.queryCondition.pageNum = 1
      this.queryData();
    },
    addList() {
      this.$router.push({
        path: "/rmcProt3P/detail",
        query: {

        }
      })
    },
    pageSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    pageNumberChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
    downloadAuditReport() {
      prot3p.downloadAuditReport({ reportList: this.multipleSelection }).then((res) => {
        fileService.respToFile(res);
      })
    },
    exportHistoryReport() {
      prot3p.exportHistoryReport({ reportList: this.multipleSelection }).then((res) => {
        fileService.respToFile(res, 'Protein 审核报告历史记录报表.xlsx');
      })
    },
    exportAslAuditReport() {
      prot3p.exportAslAuditReport({ reportList: this.multipleSelection }).then((res) => {
        fileService.respToFile(res, 'ASL审核报告报表.xlsx');
      })
    },
    approve() {
      console.log("批准")
    },
    sendBack() {
      console.log("退回")
    },
    exportData() {
      let ids = []
      this.multipleSelection.forEach((v) => {
        ids.push(v.ttRmcProteinMedicineUsageId)
      })
      this.queryCondition.proteinMedicineIds = ids
      medicineDosage.exportMedicineUsage(this.queryCondition).then((res) => {
        fileService.respToFile(res);
      })
      console.log("导出")
    },
    selectionChange(val) {
      this.multipleSelection = val
    },
    handleClose() {
      this.dialogVisible = false
      this.queryData()
    },

  },
  extends: commonFunction
}
</script>
<style scoped >
.info_box_title {
  height: 30px;
  margin-top: 10px !important;
  display: flex;
  flex-direction: row;
  justify-content: start;
}
.line {
  width: 3px;
  height: 16px;
  margin: 7px 0;
  background-color: #f8ab01;
}
.info_title {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  margin-left: 5px;
}
</style>
